import { render, staticRenderFns } from "./Telecommunication.vue?vue&type=template&id=e66553e6&"
import script from "./Telecommunication.vue?vue&type=script&lang=js&"
export * from "./Telecommunication.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports